import React, { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';
import { API } from '../utils/api';
import { useAuth } from './AuthContext';

const PointsContext = createContext(null);

export const usePoints = () => {
  const context = useContext(PointsContext);
  if (!context) {
    throw new Error('usePoints must be used within PointsProvider');
  }
  return context;
};

export const PointsProvider = ({ children }) => {
  const { token } = useAuth();
  const [points, setPoints] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchPoints = async () => {
    try {
      const response = await axios.get(`${API}/users/me`);
      setPoints(response.data.points || 0);
      setLoading(false);
    } catch (error) {
      console.error('Failed to fetch points:', error);
      setLoading(false);
    }
  };

  const refreshPoints = () => {
    fetchPoints();
  };

  useEffect(() => {
    if (token) {
      fetchPoints();
    } else {
      setPoints(0);
      setLoading(false);
    }
  }, [token]);

  return (
    <PointsContext.Provider value={{ points, refreshPoints, loading }}>
      {children}
    </PointsContext.Provider>
  );
};

export default PointsContext;
